'use strict';

module.exports = require('../5/CheckObjectCoercible');



//////////////////
// WEBPACK FOOTER
// ./node_modules/es-abstract/2021/RequireObjectCoercible.js
// module id = 37
// module chunks = 1